/**
 * ShinyText — Metallic shimmer effect on text/badges.
 * Inspired by React Bits ShinyText component.
 */
export default function ShinyText({ children, className = "", speed = 3 }) {
  return (
    <span
      className={`relative inline-block ${className}`}
      style={{
        backgroundImage:
          "linear-gradient(120deg, rgba(255,255,255,0) 30%, rgba(255,255,255,0.6) 50%, rgba(255,255,255,0) 70%)",
        backgroundSize: "200% 100%",
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        animation: `shiny-sweep ${speed}s ease-in-out infinite`,
      }}
    >
      {children}
      <style>{`
        @keyframes shiny-sweep {
          0% { background-position: 200% center; }
          100% { background-position: -200% center; }
        }
      `}</style>
    </span>
  );
}
